import { render, staticRenderFns } from "./editallocationrules.vue?vue&type=template&id=5e6ac67b&"
import script from "./editallocationrules.vue?vue&type=script&lang=ts&"
export * from "./editallocationrules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editallocationrules.vue"
export default component.exports